// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2TtME","list":"PatternAutocomplete_list__HvkuC"};